
// Notre implémentation du loading button.

// On pourra peut-être la simplifier à la prochaine version de materialui : https://next--material-ui.netlify.app/components/buttons/#loading-buttons



import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';

import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';

import { green } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },
}));

export default function LoadingButton({ disabled, onClick, label, pending, color, icon, style, tooltip, mode, ...rest }) {

    const classes = useStyles();

    if (mode === "loupe") {

        return (
        
            <IconButton
                disabled={disabled || pending}
                onClick={onClick}
                size="large"
                color={color}
            >
            
                {pending && <CircularProgress size={24} className={classes.buttonProgress} />}
                {!pending && <SearchIcon />}
            </IconButton>
        
        );

    }

    if (tooltip) {
        return (
            <Tooltip title={tooltip}>
                <span>
                    <Button
                        disabled={disabled || pending}
                        onClick={onClick}
                        variant="contained"
                        color={color}
                        style={style}
                        {...rest}
                    >
                        {icon}{label}
                        {pending && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button>
                </span>
            </Tooltip>
        
        );
    }
    return (
        <Button
            disabled={disabled || pending}
            onClick={onClick}
            variant="contained"
            color={color}
            style={style}
            {...rest}
        >
            {icon}{label}
            {pending && <CircularProgress size={24} className={classes.buttonProgress} />}
        </Button>
    );
}


LoadingButton.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    pending: PropTypes.bool.isRequired,
    color: PropTypes.string,
    tooltip: PropTypes.string,
    mode: PropTypes.string,
};


LoadingButton.defaultProps = {
    color: "secondary",
};